/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomizedResultAreaGeometry } from "./CustomizedResultAreaGeometry";
import {
  CustomizedResultAreaGeometryFromJSON,
  CustomizedResultAreaGeometryFromJSONTyped,
  CustomizedResultAreaGeometryToJSON,
  CustomizedResultAreaGeometryToJSONTyped,
} from "./CustomizedResultAreaGeometry";
import type { SubsetsEnum } from "./SubsetsEnum";
import {
  SubsetsEnumFromJSON,
  SubsetsEnumFromJSONTyped,
  SubsetsEnumToJSON,
  SubsetsEnumToJSONTyped,
} from "./SubsetsEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface CustomizedResultArea
 */
export interface CustomizedResultArea {
  /**
   *
   */
  readonly url?: string;
  /**
   * Name of the customized results area.
   */
  name: string;
  /**
   * The subsets for which the customized results area is defined.
   */
  subsets: Array<SubsetsEnum>;
  /**
   *
   */
  geometry: CustomizedResultAreaGeometry;
}

/**
 * Check if a given object implements the CustomizedResultArea interface.
 */
export function instanceOfCustomizedResultArea(value: object): value is CustomizedResultArea {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("subsets" in value) || value["subsets"] === undefined) return false;
  if (!("geometry" in value) || value["geometry"] === undefined) return false;
  return true;
}

export function CustomizedResultAreaFromJSON(json: any): CustomizedResultArea {
  return CustomizedResultAreaFromJSONTyped(json, false);
}

export function CustomizedResultAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CustomizedResultArea {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"],
    subsets: (json["subsets"] as Array<any>).map(SubsetsEnumFromJSON),
    geometry: CustomizedResultAreaGeometryFromJSON(json["geometry"]),
  };
}

export function CustomizedResultAreaToJSON(json: any): CustomizedResultArea {
  return CustomizedResultAreaToJSONTyped(json, false);
}

export function CustomizedResultAreaToJSONTyped(
  value?: Omit<CustomizedResultArea, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    subsets: (value["subsets"] as Array<any>).map(SubsetsEnumToJSON),
    geometry: CustomizedResultAreaGeometryToJSON(value["geometry"]),
  };
}
